import React, { useRef } from 'react';
import {
    Button,
    Grid,
    Typography,
    CircularProgress, ButtonGroup, Popper, Grow, Paper, MenuList, MenuItem
} from '@material-ui/core';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import AddIcon from '@material-ui/icons/AddRounded';
import axios from 'axios';
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import EditOutLinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutLinedIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import dayjs from 'dayjs';

class ScheduleBatchList extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            pageNo: 0,
            recordsPerPage: 50,
            sortKey: "lastUpdatedDt",
            sortDir: "desc",
            count: 0,
            endDateColumnIndex: 2,
            noOfQuestions: [],
            noOfQuestion: 0,
            data: [["Loading Data..."]],
            columns: [
                {
                    name: "name",
                    label: "Batch Name",
                    options: {
                        expandableRows: true
                    }
                },
                {
                    name: "startDate",
                    label: "Batch Date with Start and End Time",
                    options: {
                        filter: false,
                        customBodyRender: (value, tableMeta) => {
                            let endTimeFromEndDate = tableMeta.rowData[this.state.endDateColumnIndex];
                            let slicedEndTimeFromEndDate = endTimeFromEndDate !== undefined ? endTimeFromEndDate.slice(11, 16) : '';
                            if (value !== undefined) {
                                var customParseFormat = require('dayjs/plugin/customParseFormat')
                                dayjs.extend(customParseFormat)
                                return   dayjs(value,"DD-MM-YYYY HH:mm").format('DD-MM-YYYY hh:mm a') + " - " + dayjs(slicedEndTimeFromEndDate,"HH:mm").format('hh:mm a')
                                // return <div>
                                //     <span> {value + " - " + slicedEndTimeFromEndDate} </span>
                                // </div>;
                            }
                        }
                    }
                },
                {
                    name: "endDate",
                    label: "End Date & Time",
                    options: {
                        filter: false,
                        display: 'excluded'
                    }
                },
                {
                    name: "exam.name",
                    label: "Round Name",
                    options: {
                        filter: false
                    }
                },
                {
                    name: "lastUpdatedDt",
                    label: "Last Updated Date",
                    options: {
                        filter: false,
                        display: false,
                    }
                },
                {
                    name: "lastUpdatedBy",
                    label: "Last Updated By",
                    options: {
                        filter: false,
                        display: false,
                    }
                },
                {
                    name: "studentList.length",
                    label: "No of Students",
                    options: {
                        filter: false,
                        sort: false,
                    }
                },
                {
                    name: "createdDt",
                    label: "Created Date",
                    options: {
                        filter: false,
                        display: false,
                    }
                },
                {
                    name: "createdBy",
                    label: "Created By",
                    options: {
                        filter: false,
                        display: false,
                    },

                },

            ],
            isLoading: false,
            body: {
                name: "",
                branch: {
                    branchId: JSON.parse(localStorage.getItem("sip-user")).branch.branchId
                },
                exam: {
                    examination: {
                        examinationId: props.examinationId
                        
                    }
                }
            },
            open: false,
            openActiveBatch: false,
            openScheduleWorkshop: false,
            openRegisterStudent: false,
            branchId: JSON.parse(localStorage.getItem("sip-user")).branch.branchId,
            examinationId:props.examinationId
        };

        this.getData = this.getData.bind(this);
        this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
        this.sort = this.sort.bind(this);
    }


    componentDidMount() {
        this.getData(this.state.pageNo, this.state.sortKey, this.state.sortDir, this.state.recordsPerPage);
    }

    handleFilterSubmit = applyFilters => {
        let filterList = applyFilters();
        let selectedNameFilterValue = "";
        let selectedBranchNameFilterValue = "";
        filterList[0].forEach(element => {
            selectedNameFilterValue = element;
        });
        filterList[1].forEach(element => {
            selectedBranchNameFilterValue = element;
        });

        this.setState({
            body: {
                name: selectedNameFilterValue,
                branch: {
                    name: (selectedBranchNameFilterValue !== "" ? selectedBranchNameFilterValue : ""),
                    branchId: 0
                },
                exam: {
                    examination: {
                        examinationId: this.state.examinationId
                    }
                }
            }
        }, () => this.getData(this.state.page, this.state.sortKey, this.state.sortDir, this.state.recordsPerPage));

    }


    async getData(pageNo, sortKey, sortDir, recordsPerPage) {
        this.setState({ isLoading: true });
        const BASE_URL = `${process.env.REACT_APP_API_URL}`;
        await axios.get(BASE_URL + "/SIPCustomApi/branches/" + this.state.branchId + "/batches",
            {
                params: {
                    body: JSON.stringify(this.state.body),
                    pageNo: pageNo !== undefined ? pageNo : "",
                    sortKey: sortKey !== undefined ? sortKey : "",
                    sortDir: sortDir !== undefined ? sortDir : "",
                    recordsPerPage: recordsPerPage !== undefined ? recordsPerPage : "",
                },
                headers: {
                    authorization: 'Bearer ' +  localStorage.getItem("sip-authorization")
                }
            }).then((response) => {
                this.setState({ data: response.data.content, count: response.data.totalElements });

            });
        this.setState({ isLoading: false });

    }

    changePage = (page, sortOrder, rowsPerPage) => {
        this.setState({
            isLoading: true,
        });
        this.getData(page, sortOrder.name, sortOrder.direction, rowsPerPage);
    }

    changeRecordPerPage = (page, sortOrder, rowsPerPage) => {
        this.getData(page, "", "", rowsPerPage);
    }

    sort = (page, sortOrder, rowsPerPage) => {
        this.getData(page, sortOrder.name, sortOrder.direction, rowsPerPage);
    }

    handleSearch = (searchText, page, sortOrder, rowsPerPage) => {
        this.setState({
            pageNo: page,
            sortKey: sortOrder.name,
            sortDir: sortOrder.direction,
            body: {
                name: (searchText != null ? searchText : ""),
                branch: {
                    branchId: JSON.parse(localStorage.getItem("sip-user")).branch.branchId
                },
                exam: {
                    examination: {
                        examinationId: this.state.examinationId
                    }
                }
            }
        }, () => this.getData(page, sortOrder.name, sortOrder.direction, rowsPerPage));
    }

    render() {

        const { count, rowsPerPage, sortOrder } = this.state;

        const options = {
            filter: true,
            filterType: 'dropdown',
            responsive: 'vertical',
            serverSide: true,
            count: count,
            rowsPerPage: rowsPerPage,
            rowsPerPageOptions: [10, 20, 50, 100],
            sortOrder: sortOrder,
            expandableRows: true,
            expandableRowsHeader: false,
            expandableRowsOnClick: true,
            confirmFilters: true,
            selectableRows: false,
            rowHover: true,
            caseSensitive: true,
            enableNestedDataAccess: '.',
            print: false,
            searchOpen: true,
            onFilterChipClose: () => {
                this.setState(
                    {
                        body: {
                            name: "",
                            branch: {
                                branchId: 0
                            },
                            exam: {
                                examination: {
                                    examinationId: this.state.examinationId
                                }
                            }
                        }
                    }, () => {
                        this.componentDidMount()
                    })
            },
            onFilterDialogClose: () => {
                this.componentDidMount()
            },
            isRowExpandable: (dataIndex, expandedRows) => {
                return true;
            },
            rowsExpanded: [],
            renderExpandableRow: (rowData, rowMeta) => {
                
                const colSpan = rowData.length + 1;
                if (this.state.data[rowMeta.dataIndex]) {
                    const studentData = this.state.data[rowMeta.dataIndex].studentList;

                    return (
                        <TableRow>
                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={colSpan}>
                                
                                <Box margin={1}>
                                    <Typography variant="h6" gutterBottom component="div">
                                        Students
              </Typography>
                                    <Table size="small" aria-label="purchases">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Name</TableCell>
                                                <TableCell>Parent Name</TableCell>
                                                <TableCell >Class</TableCell>
                                                <TableCell >School</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody >

                                            {studentData && studentData.map((row) => (

                                                <TableRow key={row.studentId}>
                                                    <TableCell component="th" scope="row">
                                                        {row.childName}
                                                    </TableCell>
                                                    <TableCell>{row.parentName}</TableCell>
                                                    <TableCell >{row.classNumber.name}</TableCell>
                                                    <TableCell >{row.schoolName.schoolName}</TableCell>
                                                   
                                                </TableRow>
                                            ))}

                                        </TableBody>
                                    </Table>
                                </Box>
                                
                            </TableCell>
                        </TableRow>
                        
                    );
                }
            },
            onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => console.log(curExpanded, allExpanded, rowsExpanded),

            customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
                return (
                    <div style={{ marginTop: '40px' }}>
                        <Grid container>
                            <Grid item xs={5}>
                                <Button color="primary" variant="contained" onClick={() => this.handleFilterSubmit(applyNewFilters)}>Filter</Button>
                            </Grid>

                        </Grid>
                    </div>
                );
            },

            // callback that gets executed when filters are confirmed
            onFilterConfirm: (filterList) => {
            },

            onFilterDialogOpen: () => {
            },
            searchPlaceholder: 'Search by Batch Name...',
            onTableChange: (action, tableState) => {


                switch (action) {
                    case 'changePage':
                        this.changePage(tableState.page, tableState.sortOrder, tableState.rowsPerPage);
                        break;
                    case 'sort':
                        this.sort(tableState.page, tableState.sortOrder, tableState.rowsPerPage);
                        break;
                    case 'changeRowsPerPage':
                        this.changeRecordPerPage(tableState.page, tableState.sortOrder, tableState.rowsPerPage);
                        break;
                    case 'search':
                        this.handleSearch(tableState.searchText, tableState.page, tableState.sortOrder, tableState.rowsPerPage);
                        break;
                    default:
                        console.log('action not handled.');
                }
            }
        };

        const theme = createMuiTheme({
            overrides: {
                MUIDataTableSelectCell: {
                    expandDisabled: {
                        // Soft hide the button.
                        visibility: 'hidden',
                    },
                },
            },
        });

        const components = {
            ExpandButton: function (props) {
                //   if (props.dataIndex === 3 || props.dataIndex === 4) return <div style={{width:'24px'}} />;
                return <ExpandButton {...props} />;
            }
        };

        return (
            <div className="container">
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <MUIDataTable
                            theme={theme}
                            title={<Typography variant="h6">
                                Schedule Batches
                        {this.state.isLoading && <CircularProgress size={24} style={{ marginLeft: 15, position: 'relative', top: 4 }} />}
                            </Typography>
                            }
                            data={this.state.data}
                            columns={this.state.columns}
                            options={options}
                            components={components}
                        />
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default ScheduleBatchList;
